var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('BaseContainer',{staticClass:"main-header__container"},[_c('BaseLogo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }